export default __webpack_public_path__ + "static/157-bd7ad8671097fed80dd025b4f8dc04cb.jpg";